module.exports = __webpack_public_path__ + "static/media/it.1264f3cf.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/it.svg
// module id = 2122
// module chunks = 0